import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/material-order", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/material-order/csv", params);
};

const upsert = data => {
  return restApi.post("/api/material-order/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/material-order/${ids}`);
};

const checkDuplicateOrderNum = params => {
  return restApi.get("/api/material-order/duplicate-check", { params });
}

const materialOrderService = {
  getAll,
  getAllForCSV,
  upsert,
  remove,
  checkDuplicateOrderNum
};

export default materialOrderService;